module.exports = __webpack_public_path__ + "static/image/history/m/201506_2@3x.ver2_0_2.jpg?abf6f75d";